function openDiscountModal(message) {
  const modal = document.getElementById("discount-modal");
  const text = document.getElementById("discount-modal-text");

  if (!modal || !text) return;

  text.textContent = message;

  modal.hidden = false;

  // force reflow so animation always plays
  modal.offsetHeight;

  modal.classList.add("is-open");
  document.body.classList.add("discount-modal-open");
}


function closeDiscountModal() {
  const modal = document.getElementById("discount-modal");
  if (!modal) return;

  modal.classList.remove("is-open");

  setTimeout(() => {
    modal.hidden = true;
    document.body.classList.remove("discount-modal-open");
  }, 250); // match CSS duration
}

// document.addEventListener("DOMContentLoaded", () => {
//   if (!window.discountCollections || !window.discountCollections.length) return;

//   const STORAGE_KEY = "shown_discount_collections";
//   const shown =
//     JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || [];

//   const collectionToShow = window.discountCollections.find(
//     (c) => !shown.includes(c.handle)
//   );

//   if (!collectionToShow) return;

//   openDiscountModal(collectionToShow.message);

//   shown.push(collectionToShow.handle);
//   sessionStorage.setItem(STORAGE_KEY, JSON.stringify(shown));
// });

function initDiscountModal() {
  if (!window.discountCollections || !window.discountCollections.length) return;

  const STORAGE_KEY = "shown_discount_collections";
  const shown =
    JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || [];

  const collectionToShow = window.discountCollections.find(
    (c) => !shown.includes(c.handle)
  );

  if (!collectionToShow) return;
  if (!collectionToShow.message) return;

  openDiscountModal(collectionToShow.message);

  shown.push(collectionToShow.handle);
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(shown));
}

// Run immediately if DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initDiscountModal);
} else {
  initDiscountModal();
}

// Close handlers
document.addEventListener("click", (e) => {
  if (
    e.target.id === "discount-modal-close" ||
    e.target.classList.contains("discount-modal__overlay")
  ) {
    closeDiscountModal();
  }
});
